/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconMessages is deprecated and will be archived soon. Use IconMessages instead.
 */

export function Experimental__IconMessages(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path d='M15.002 1.998a2 2 0 00-2-1.998H3.018a2 2 0 00-2 1.998l-.006 7.997a2 2 0 001.996 2.002L4.757 12l3.253 3.808L11.263 12l1.749-.003a2 2 0 001.996-2.002l-.006-7.997zm-1.992 8.999L11.261 11l-.46.001-.299.35-2.492 2.918-2.493-2.918-.299-.35L4.759 11l-1.749-.003a1.001 1.001 0 01-.998-1.001l.006-7.997a1.001 1.001 0 011-.999h9.984c.551 0 .999.448 1 .999l.006 7.997c.001.55-.447 1-.998 1.001zM4 5.001h8v-1H4v1zM4 8h8V7H4v1z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M6 13.001h12v-1H6v1zM17.999 2H6a3.998 3.998 0 00-4 3.997v8.009A3.997 3.997 0 006 18h1.615l4.4 5.154 4.4-5.154h1.584c2.209 0 4-1.792 4-4.001 0-2.668.002-5.335 0-8.003a4.001 4.001 0 00-4-3.996zm3 11.999a3.004 3.004 0 01-3 3.001h-2.045l-3.939 4.614L8.076 17H6a3.001 3.001 0 01-3-2.995V5.997A3.002 3.002 0 016 3h11.999a3.003 3.003 0 013 2.996v8.003zM6 8h12V7H6v1z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M24.002 3.009C19.399 3.005 12.606 3.002 8.004 3h-.002c-2.762 0-5 2.234-5.001 4.997v10.014a5 5 0 005.003 4.998h2.436l5.556 6.504 5.556-6.504h2.439a5 5 0 005.003-4.994c.004-3.328-.009-6.655.007-9.982a5 5 0 00-4.999-5.024zm3.991 15.005a4.007 4.007 0 01-4.003 3.995h-2.9l-5.095 5.965-5.095-5.965H8.004a4.007 4.007 0 01-4.003-3.998V7.997A4.005 4.005 0 018.002 4h.002c4.602.002 11.395.005 15.998.009a3.976 3.976 0 012.836 1.18A3.97 3.97 0 0128 8.027c-.01 2.11-.009 4.22-.007 6.331.001 1.218.002 2.437 0 3.656zM9 11h14v-1H9v1zm0 5.001h14v-1H9v1z'/>"
  }, {
    size: 48,
    svgContent: "<path d='M12.994 25.001h22v-2h-22v2zm30.994-14.009A7.987 7.987 0 0035.996 3H11.993a7.987 7.987 0 00-7.992 7.992v17.016C4.001 32.426 7.583 36 12 36h4.69l7.304 8.551L31.298 36h4.69c4.418 0 8-3.574 8-7.992V10.992zm-2 17.016c0 3.304-2.692 5.992-6 5.992h-5.612l-.599.701-5.783 6.771-5.783-6.771-.599-.701H12c-3.308 0-5.999-2.688-6-5.992V10.992A6 6 0 0111.993 5h24.003a5.999 5.999 0 015.992 5.993v17.015zM12.994 16h22v-2h-22v2z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M16.999 36.998h30v-2h-30v2zm0-11h30v-2h-30v2zm32.963-14.999h-36c-4.4 0-8 3.6-8 8v22c0 4.4 3.6 8 8 8h6.894L31.962 62l11.106-13.001h6.894c4.4 0 8-3.6 8-8v-22c0-4.4-3.6-8-8-8zm6 30c0 3.309-2.691 6-6 6h-7.816l-.599.701-9.585 11.221L22.378 47.7l-.599-.701h-7.816c-3.309 0-6-2.691-6-6v-22c0-3.309 2.692-6 6-6h36c3.309 0 6 2.691 6 6v22z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M12 5H4V3.5h8V5zm0 3.5H4V7h8v1.5z'/><path d='M0 0h16v12h-4.415L8 15.585 4.414 12H0V0zm1.5 1.5v9h3.536L8 13.464l2.964-2.964H14.5v-9h-13z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M18 9H6V7h12v2zm0 5H6v-2h12v2z'/><path d='M1 3a1 1 0 011-1h20a1 1 0 011 1v15a1 1 0 01-1 1h-5.586l-3.707 3.707a1 1 0 01-1.414 0L7.586 19H2a1 1 0 01-1-1V3zm2 1v13h5a1 1 0 01.707.293L12 20.586l3.293-3.293A1 1 0 0116 17h5V4H3z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconMessages;